import { APP_CONFIG } from '../../config/appConfig';

const normalizeIdentifier = (value) => String(value || '').trim().toLowerCase();

export const ADMIN_AUTH_POLICY = Object.freeze({
  email: normalizeIdentifier(APP_CONFIG.auth.adminEmail),
  legacyUsername: normalizeIdentifier(APP_CONFIG.auth.legacyAdminUsername),
  legacyPassword: APP_CONFIG.auth.legacyAdminPassword || '',
});

export const isAdminEmail = (email) => {
  if (!ADMIN_AUTH_POLICY.email) {
    return false;
  }

  return normalizeIdentifier(email) === ADMIN_AUTH_POLICY.email;
};

export const canUseLegacyAdminLogin = () =>
  Boolean(
    ADMIN_AUTH_POLICY.email &&
      ADMIN_AUTH_POLICY.legacyUsername &&
      ADMIN_AUTH_POLICY.legacyPassword
  );

export const matchesLegacyAdminCredentials = ({ identifier, password }) =>
  canUseLegacyAdminLogin() &&
  normalizeIdentifier(identifier) === ADMIN_AUTH_POLICY.legacyUsername &&
  password === ADMIN_AUTH_POLICY.legacyPassword;

